import { Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CorporateService } from "../corporate.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-corporate-cancel-trip',
  templateUrl: './corporate-cancel-trip.component.html',
  styleUrls: ['./corporate-cancel-trip.component.css']
})
export class CorporateCancelTripComponent{
  loading = false;
  token = sessionStorage.getItem("corporate_token");

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CorporateCancelTripComponent>,
    private service: CorporateService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  cancelTrip(): void {
    this.loading = true;
    const payload = { reason: 'Cancelled by user' };

    this.service.cancellationTrip(this.data._id, payload, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.snackBar.open('Trip cancelled successfully.', 'Success', { duration: 4000 });
          this.dialogRef.close('refresh');
          location.reload();
        }
        this.loading = false;
      },
      (error: any) => {
        this.loading = false;
        if (['jwt expired', 'jwt malformed'].includes(error.error.message)) {
          this.router.navigateByUrl('/');
          localStorage.clear();
        }
        this.snackBar.open(error.error.message || 'Error cancelling trip', 'Fail', { duration: 5000 });
      }
    );
  }
}

